module.exports = __webpack_public_path__ + "img/product_34.a70260b.webp";